exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".swipe-wrap::after {\n  content: '';\n  display: block;\n  clear: both;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/style.css
// module id = 200
// module chunks = 0